import { css, cx } from "@emotion/css";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import PauseIcon from "src/images/Icons/newIcons/controllers/pause.svg";
import PlayIcon from "src/images/Icons/newIcons/controllers/play.svg";
import { ExamState } from "src/types/enums";

import { IconButton } from "../../../Default/LekUI/Button";
import { Tooltip } from "../../../Default/LekUI/Tooltip";
import { useTimer } from "./Timer";

dayjs.extend(duration);

export const ExamTimer = ({
	pausedAt,
	finishedAt,
	onFinished,
	state,
	togglePause,
	isLoading,
}) => {
	const { t } = useTranslation();
	const isPaused = state === ExamState.PAUSED;
	const Icon = isPaused ? PlayIcon : PauseIcon;
	const time = useTimer({ pausedAt, finishedAt, onFinished, state });
	const ref = useRef();

	return (
		<div className="exam-timer" data-test-id="exam-timer">
			<span className="size-16-light flex-center-row">
				{t("exam.timer.finishedAt")}
			</span>
			<div ref={ref} className="flex-center-row gap-4">
				<span
					className={cx(
						`size-18 ${isPaused ? "text-error" : "text-primary"}`,
						css`
              min-width: 80px;
            `,
					)}
				>
					{time}
				</span>
				<Tooltip title={t("exam.timer.startTimer")} open={false}>
					<IconButton
						isLoading={isLoading}
						size="small"
						className="menu-icon-button p-6"
						onClick={togglePause}
						disableRipple
						data-test-id="exam-timer-pause-button"
					>
						<Icon className={cx("icon-small icon-black")} />
					</IconButton>
				</Tooltip>
			</div>
		</div>
	);
};
